module.exports = __webpack_public_path__ + "img/amazon-chromecast.0f3af200.jpg";